import { render, staticRenderFns } from "./PreviewAvatar.vue?vue&type=template&id=08704e5f&scoped=true&"
import script from "./PreviewAvatar.vue?vue&type=script&lang=js&"
export * from "./PreviewAvatar.vue?vue&type=script&lang=js&"
import style0 from "./PreviewAvatar.vue?vue&type=style&index=0&id=08704e5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08704e5f",
  null
  
)

export default component.exports